import React from "react";
import { graphql, Link, StaticQuery } from "gatsby";


const DocList = ({ location }) => (
  <StaticQuery
    query={graphql`
      query {
        allMdx(sort: {fields: slug}) {
          group(field: frontmatter___section) {
            edges {
              node {
                fields {
                  slug
                  title
                }
                frontmatter {
                  section
                }
              }
            }
          }
        }
      }
    `}
    render={({ allMdx }) => {
      return (
        <div className="container-fluid" style={{ fontFamily: "Roboto" }}>
          <h3 className="mt-3">Documentation</h3>
          <hr />
          {allMdx.group.map((group, key) => <DocumentSection key={key} documents={group.edges} />)}
          <br className="mt-5" />
        </div>
      );
    }}
  />
);

export default DocList;

const DocPage = (props) => {
  let { doc } = props;

  return (
    <div>
      <Link className="mt-2 ml-2 text-dark" to={doc.slug}>
        {doc.title}
      </Link>
    </div>
  );
};

const DocumentSection = props => {
  let {documents} = props;

  let section = documents[0].node.frontmatter.section

  if (!section || section == ""){
    return null
  }

  if (section === "Tutorials" && documents[documents.length-1].node.fields.title !== "All Tutorials"){
    documents.push({node: {fields: {slug: "/tutorials/", title: "All Tutorials"}}})
  }

  return (
    <div className="mt-5">
      <h4>{section}</h4>
      <hr />
      {documents.map((doc, index) => <DocPage key={index} doc={doc.node.fields}/>)}
    </div>
  );
};